import * as React from "react";
import { Icon, Stack, Typography, Box, Link } from "@mui/material";
import { TBreakpointLabels } from "../../utils/constants/hooks/breakpoints";
import { useXPathValue } from "../../hooks/useXPath";
import { useXoraiaValue } from "../../hooks/useXoraia";

const BrowserHeader: React.FC<{
  domain?: string;
  breakpoint: TBreakpointLabels;
}> = ({ domain, breakpoint }) => {
  return (
    <Stack
      className="x-browser-header"
      width="100%"
      alignItems={"center"}
      direction="row"
      bgcolor="#1C2B45"
      px={3}
      height={50}
      spacing={2}
      py={1}
      zIndex={10}
      position="relative"
    >
      {/* <BrowserDots /> */}
      {breakpoint !== "mobile" && <BrowserDots />}
      {breakpoint !== "mobile" && <BrowserArrows />}
      {breakpoint !== "mobile" && <BrowserIcon name="fi fi-rr-refresh" />}

      <BrowserUrlInput domain={domain} />
      <BrowserIcon name="fi fi-rr-menu-dots-vertical" />
    </Stack>
  );
};

export default BrowserHeader;

const BrowserDot: React.FC<{ color: string }> = ({ color }) => {
  return <Box width={12} height={12} borderRadius="50%" bgcolor={color} />;
};

const BrowserIcon: React.FC<{
  name: string;
  fontSize?: number;
  color?: string;
}> = ({ name, fontSize, color }) => {
  return (
    <Icon
      sx={{
        color: color || "#7D8897",
        "&.material-icons": {
          fontSize: fontSize || 15,
        },
        "&::before": {
          color: "inherit",
          lineHeight: "1em",
          fontSize: fontSize || 15,
        },
      }}
      className={name}
    />
  );
};

const BrowserArrows: React.FC = () => {
  return (
    <Stack direction={"row"} alignItems="center" spacing={1}>
      <BrowserIcon name="fi fi-rr-arrow-small-left" fontSize={25} />
      <BrowserIcon name="fi fi-rr-arrow-small-right" fontSize={25} />
    </Stack>
  );
};

const BrowserDots: React.FC = () => {
  return (
    <Stack direction={"row"} alignItems="center" spacing={1.5}>
      <BrowserDot color="#E85F59" />
      <BrowserDot color="#EE8437" />
      <BrowserDot color="#54B489" />
    </Stack>
  );
};

const BrowserPath: React.FC<{ domain?: string }> = () => {
  const path = useXPathValue();
  const { domain } = useXoraiaValue();

  return (
    <Link
      href={domain ? `https://${domain}${path}` : undefined}
      target="_blank"
      sx={{ "&:hover": { textDecoration: "none" } }}
    >
      <Typography color="white" fontSize={14}>
        <Typography component="span" color="#7D8897" fontSize="inherit">
          https://
        </Typography>
        {(domain ?? "mywebsite.com") + path}
      </Typography>
    </Link>
  );
};

const BrowserUrlInput: React.FC<{ domain?: string }> = ({ domain }) => {
  return (
    <Stack
      direction={"row"}
      alignItems="center"
      spacing={1}
      bgcolor="#34415A"
      px={2}
      py={0.5}
      borderRadius={3}
      flex={1}
    >
      <BrowserIcon name="fi fi-rr-lock" color="#54B489" />
      <BrowserPath domain={domain} />
    </Stack>
  );
};
